const SERVER_FIELDS = {
  billto_postal_code: 'postal_code',
}

export default SERVER_FIELDS
